import React from 'react';
import PropTypes from 'prop-types';
import { chartTheme } from './chartTheme';

const CustomXAxisTick = ({ x, y, payload, handleLabelClick }) => {
  return (
    <g
      transform={`translate(${x}, ${y})`}
      style={{
        cursor: 'pointer',
        fill: chartTheme.main,
      }}
      onClick={() => {
        handleLabelClick(payload.value);
      }}
    >
      <text
        x={0}
        y={0}
        dy={10}
        textAnchor="end"
        fontSize={12}
        transform="rotate(-35)"
        style={{
          fontWeight: 'bold',
        }}
      >
        {payload.value}
      </text>
    </g>
  );
};

export default CustomXAxisTick;

CustomXAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({
    value: PropTypes.string,
  }),
  handleLabelClick: PropTypes.func.isRequired,
};
